var _circle, _circle2, _circle3, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssetKuroModalUbuntuIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ubuntu",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.015,
    height: 27.157,
    viewBox: "0 0 27.015 27.157",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 2.829,
    cy: 2.829,
    r: 2.829,
    transform: "translate(0 10.75)",
    fill: "#ff5722"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 2.829,
    cy: 2.829,
    r: 2.829,
    transform: "translate(18.667 21.5)",
    fill: "#ff5722"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 2.829,
    cy: 2.829,
    r: 2.829,
    transform: "translate(18.667)",
    fill: "#ff5722"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    d: "M219.345,48.3a.566.566,0,0,0,.628.266,5.625,5.625,0,0,1,6.821,3.937.566.566,0,0,0,.544.412h4.624a.566.566,0,0,0,.559-.655,11.286,11.286,0,0,0-2.573-5.568.566.566,0,0,0-.742-.1,3.957,3.957,0,0,1-6.152-3.241.566.566,0,0,0-.506-.554,11.35,11.35,0,0,0-5.233.686.566.566,0,0,0-.287.811Z",
    transform: "translate(-205.514 -40.472)",
    fill: "#ff5722"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M232.088,277.333h-4.624a.566.566,0,0,0-.544.412,5.623,5.623,0,0,1-6.821,3.937.566.566,0,0,0-.628.266l-2.313,4.007a.566.566,0,0,0,.287.811,11.174,11.174,0,0,0,5.233.686.566.566,0,0,0,.506-.554,3.951,3.951,0,0,1,6.145-3.241.566.566,0,0,0,.743-.1,11.286,11.286,0,0,0,2.573-5.565.566.566,0,0,0-.469-.648A.575.575,0,0,0,232.088,277.333Z",
    transform: "translate(-205.639 -262.623)",
    fill: "#ff5722"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M104.453,101.059a5.646,5.646,0,0,1,0-7.879.566.566,0,0,0,.084-.679l-2.309-4a.566.566,0,0,0-.388-.274.59.59,0,0,0-.459.113,11.325,11.325,0,0,0-3.567,5.109.566.566,0,0,0,.175.621,3.9,3.9,0,0,1,0,6.1.566.566,0,0,0-.175.621,11.325,11.325,0,0,0,3.566,5.1.566.566,0,0,0,.358.127.62.62,0,0,0,.1-.009.566.566,0,0,0,.388-.274l2.309-4A.566.566,0,0,0,104.453,101.059Z",
    transform: "translate(-92.667 -83.542)",
    fill: "#ff5722"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetKuroModalUbuntuIcon);
export default __webpack_public_path__ + "static/media/Asset-KuroModalUbuntuIcon.621bb8b3b0438ef84823ebe06e2bdae1.svg";
export { ForwardRef as ReactComponent };